export default {
    categories: {
        outbound_call_reminder: 1,
        appointment_reminder: 2,
        lead_import: 3,
        lead_address_conversion: 4
    }
}
